export const BUSINESS = {
  name: "Silicone & Mastic Specialists",
  tagline: "Professional Silicone Sealing & Mastic Contractors Across Scotland & North East England",
  parent: "Part of Dodds Bros | British Bath Company",
  phone1: "07796 225041",
  phone1Href: "tel:+447796225041",
  phone2: "07553 457748",
  phone2Href: "tel:+447553457748",
  email: "enquiries@britishbathcompany.co.uk",
  whatsapp: "https://wa.me/447796225041?text=Hello%2C%20I%27d%20like%20a%20free%20quote%20for%20silicone%20sealing%20work.",
};

const OWNER = "https://customer-assets-rejwkqb3.emergentagent.net/job_53eff2f5-17f9-4599-a3d6-c07a89c7eb1e/artifacts";

export const IMAGES = {
  hero: {
    src: `${OWNER}/7910d016cbca0a0c_IMG_0875%202.webp`,
    alt: "Mastic specialist sealing a commercial kitchen ceiling perimeter in Scotland",
    owner: true,
  },
  showerTray: {
    src: `${OWNER}/4a2b31839f562e22_IMG_1034.webp`,
    alt: "Freshly resealed black slate shower tray with crisp white silicone lines",
    owner: true,
  },
  commercialWc: {
    src: `${OWNER}/e26bbcecd0e78594_IMG_0876%202.webp`,
    alt: "Commercial accessible WC with sage-green tiles and precise silicone sealing",
    owner: true,
  },
  showerStrip: {
    src: `${OWNER}/31b7e5f485c4419d_aee95f47-7d0d-4bfa-84a4-b69e2f410deb.JPG`,
    alt: "Operative removing old failed sealant from a domestic shower before resealing",
    owner: true,
  },
  accessibleWc: {
    src: `${OWNER}/6199e89c4b8c92d8_2468ad60-89bd-4cb3-a698-b1ca51f76543.JPG`,
    alt: "Operative applying silicone sealant in an accessible commercial washroom",
    owner: true,
  },
  sephora: {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sealing-scotland--6zv5orck/artifacts/f3d0e657d281c41d_7f2988d0-fbaf-4287-a607-4ef65c24502d.JPG",
    alt: "Commercial silicone sealing above shopfront signage at Sephora, St James Quarter, Edinburgh",
    owner: true,
  },
  suez: {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sealing-scotland--6zv5orck/artifacts/c880ee20c007bdc8_image.webp",
    alt: "Industrial joint sealant application to flooring joints at the SUEZ facility, Ashington",
    owner: true,
  },
  blankStreet: {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sealing-scotland--6zv5orck/artifacts/209ab93b60195f88_IMG_0877%202.webp",
    alt: "Precision silicone sealing to an accessible washroom basin at Blank Street Coffee, Edinburgh",
    owner: true,
  },
};

export const SERVICES = [
  { n: "01", tag: "COMMERCIAL", title: "Commercial Silicone & Mastic Sealing", desc: "Professional sealant application for commercial buildings, retail premises, offices, hotels, restaurants, developments and refurbishment projects." },
  { n: "02", tag: "INDUSTRIAL", title: "Industrial Joint Sealing", desc: "Large-scale silicone and mastic applications: floor joints, expansion joints, movement joints and industrial facilities, subject to the appropriate material specifications." },
  { n: "03", tag: "SANITARY", title: "Bathroom & Shower Resealing", desc: "Removal and replacement of old, mouldy, cracked or deteriorated silicone around baths, showers, sinks, tiles and wet rooms." },
  { n: "04", tag: "KITCHENS", title: "Kitchen Silicone Sealing", desc: "Professional sealing around worktops, sinks, splashbacks, kitchen units and adjoining surfaces." },
  { n: "05", tag: "WEATHERPROOF", title: "Window & Door Sealing", desc: "Internal and external perimeter sealing, weatherproofing and finishing work." },
  { n: "06", tag: "DEVELOPMENTS", title: "New Builds & Property Developments", desc: "Professional mastic finishing for housebuilders, developers, contractors and refurbishment companies." },
  { n: "07", tag: "HOSPITALITY", title: "Hospitality & Retail", desc: "Specialist silicone sealing for hotels, restaurants, cafés, shops, shopping centres and other commercial premises." },
  { n: "08", tag: "DOMESTIC", title: "Domestic Silicone Replacement", desc: "Small and large residential resealing jobs, including bathrooms, kitchens, utility rooms and general property maintenance." },
  { n: "09", tag: "SPECIALIST", title: "Coloured Silicone & Specialist Finishes", desc: "Professional colour-matched silicone and high-quality finishing where suitable materials are available." },
];

export const PROJECTS = [
  {
    id: "sephora",
    n: "01. RETAIL FIT-OUT",
    cat: "Commercial",
    title: "Sephora · St James Quarter",
    location: "Edinburgh",
    kicker: "Commercial Flagship",
    desc: "Substantial commercial silicone sealing across high-traffic customer areas and luxury retail fixtures in Edinburgh's St James Quarter.",
    img: IMAGES.sephora,
    placeholder: false,
  },
  {
    id: "suez",
    n: "02. INDUSTRIAL PLANT",
    cat: "Industrial",
    title: "SUEZ · Ashington",
    location: "Northumberland",
    kicker: "Industrial Facility",
    desc: "Large-scale industrial silicone and joint sealing work associated with the SUEZ recycling facility in Ashington.",
    img: IMAGES.suez,
    placeholder: false,
  },
  {
    id: "blankstreet",
    n: "03. HOSPITALITY",
    cat: "Commercial",
    title: "Blank Street Coffee",
    location: "Edinburgh",
    kicker: "Hospitality Fit-Out",
    desc: "Commercial silicone sealing and finishing work at Blank Street Coffee premises in Edinburgh — hygienic, precise sealing for food preparation perimeters and customer counters.",
    img: IMAGES.blankStreet,
    placeholder: false,
  },
  {
    id: "domestic",
    n: "04. RESIDENTIAL",
    cat: "Domestic",
    title: "Domestic Shower & Bath Reseals",
    location: "Across Scotland",
    kicker: "Residential Resealing",
    desc: "A large selection of private silicone sealing and resealing work — full removal of deteriorated sealant, careful preparation and neat precision re-caulking across bathrooms, showers and kitchens.",
    img: IMAGES.showerTray,
    placeholder: false,
  },
  {
    id: "commercial-wc",
    n: "05. COMMERCIAL WASHROOMS",
    cat: "Commercial",
    title: "Commercial Washroom Sealing",
    location: "Scotland & NE England",
    kicker: "Completed Work",
    desc: "Precise, hygienic silicone sealing to accessible washrooms, sanitaryware and tiled surfaces in commercial premises.",
    img: IMAGES.commercialWc,
    placeholder: false,
  },
  {
    id: "commercial-app",
    n: "06. SITE APPLICATION",
    cat: "Commercial",
    title: "Commercial Sealant Application",
    location: "On site",
    kicker: "Our Team At Work",
    desc: "Professional on-site application by our own operatives — clean beads, neat finishes and tidy working practices on live commercial premises.",
    img: IMAGES.accessibleWc,
    placeholder: false,
  },
];

export const WHY_US = [
  { title: "Extensive Industry Experience", desc: "25+ years' industry experience delivering professional sealing work across residential, commercial and industrial settings." },
  { title: "Projects of Every Scale", desc: "From individual shower trays to substantial commercial and industrial sealing packages." },
  { title: "Professional Workmanship", desc: "Clean application, neat finishes and attention to detail on every joint we seal." },
  { title: "Wide Geographical Coverage", desc: "Based near Edinburgh, serving customers throughout Scotland and North East England." },
  { title: "Commercial Project Experience", desc: "A portfolio involving prominent retail premises and major industrial sites." },
  { title: "Part of Dodds Bros", desc: "Operating alongside the established services of the British Bath Company." },
];

export const AREAS_SCOTLAND = [
  "Edinburgh", "Glasgow", "East Lothian", "Midlothian", "West Lothian", "Scottish Borders",
  "Fife", "Stirling", "Perth", "Dundee", "Aberdeen", "Inverness", "The Highlands", "Caithness", "John o' Groats",
];

export const AREAS_ENGLAND = [
  "Newcastle upon Tyne", "Gateshead", "Northumberland", "Ashington", "Morpeth",
  "Sunderland", "South Shields", "Washington", "County Durham", "Durham",
];

export const FAQS = [
  {
    q: "What is the difference between mastic and silicone?",
    a: "Mastic is the general trade term for flexible sealants applied with a gun, while silicone is a specific type of mastic sealant known for its flexibility, waterproofing and resistance to mould. In practice, professional mastic men choose between sanitary silicones, acrylics, hybrids and polyurethanes depending on the joint, the surface and the movement expected. We specify the right material for each job rather than using one product for everything.",
  },
  {
    q: "Do you undertake commercial mastic contracts?",
    a: "Yes. Commercial mastic contracting is a core part of our work. We undertake sealing packages for retail premises, offices, hotels, restaurants and new developments across Scotland and North East England, and we regularly work alongside main contractors, shopfitters and developers to an agreed specification and programme.",
  },
  {
    q: "Do you carry out industrial joint sealing?",
    a: "Yes. We carry out industrial silicone sealing and joint work including floor joints, expansion joints and movement joints in industrial facilities, subject to the appropriate material specifications for the environment. Our portfolio includes large-scale work associated with a major recycling facility in Northumberland.",
  },
  {
    q: "Can you replace old or mouldy bathroom silicone?",
    a: "Absolutely — bathroom silicone resealing is one of our most requested domestic services. We remove the failed or mouldy sealant completely, clean and prepare the surfaces, then apply a professional-grade sanitary silicone for a clean, watertight finish around baths, showers, sinks and wet rooms.",
  },
  {
    q: "Do you provide coloured silicone?",
    a: "Yes, we offer coloured silicone and colour-matched specialist finishes where suitable materials are available. This is popular for matching grout lines, worktops, tiles and sanitaryware so the sealant blends neatly into the finished room.",
  },
  {
    q: "Can I send photographs for a quotation?",
    a: "Yes — sending photos is the quickest way to get an accurate quote. WhatsApp them to 07796 225041, email them to enquiries@britishbathcompany.co.uk, or attach them to our quotation form. For commercial projects, drawings and specifications are also welcome.",
  },
  {
    q: "Do you cover all of Scotland?",
    a: "Yes. We are based near Edinburgh and cover the whole of Scotland — from the Scottish Borders through the central belt, Fife, Perthshire, Aberdeen and Inverness, right up through the Highlands and Caithness to John o' Groats.",
  },
  {
    q: "Do you work in Newcastle and Durham?",
    a: "Yes. We regularly undertake silicone sealing and mastic work across North East England, including Newcastle upon Tyne, Gateshead, Northumberland, Sunderland and County Durham. Larger commercial and industrial contracts can justify longer-distance travel throughout our coverage area.",
  },
  {
    q: "How long does silicone take to cure?",
    a: "Most sanitary silicones skin over within 20–30 minutes and are fully cured within 24 hours, though thicker beads and colder or damper conditions can extend this. We always explain the curing requirements for your specific job before we leave, so you know exactly when the area can get wet again.",
  },
  {
    q: "Can you work alongside other construction contractors?",
    a: "Yes. We routinely work within wider construction and fit-out programmes, coordinating with main contractors, shopfitters, tilers and plumbers. We can schedule our sealing packages around other trades and work to the main contractor's programme.",
  },
  {
    q: "Do you undertake large-scale sealing contracts?",
    a: "Yes. From substantial retail fit-outs to industrial facilities and multi-unit developments, we have the experience and capacity to undertake large-scale silicone and mastic sealing contracts across Scotland and North East England. Contact us to discuss your specification and receive a commercial quotation.",
  },
];

export const STEPS = [
  { n: "1", title: "Get In Touch", desc: "Call, email, WhatsApp or complete our quotation form." },
  { n: "2", title: "Tell Us About Your Project", desc: "Send photographs, measurements, drawings or a description of the work required." },
  { n: "3", title: "Receive Your Quote", desc: "We assess the requirements and provide a quotation." },
  { n: "4", title: "Professional Completion", desc: "Our team carries out the work to the agreed specification and programme." },
];

export const DOMESTIC_PROCESS = [
  "Assess the existing silicone.",
  "Remove failed or deteriorated sealant where necessary.",
  "Prepare and clean the surfaces.",
  "Apply suitable professional-grade sealant.",
  "Inspect the finished work and explain curing requirements.",
];
